import React, { Component} from "react";
import { withRouter } from "react-router-dom";
import {hot} from "react-hot-loader";
import {Footer, Header, TopSection, StepByStep, FAQ, Banner, LastSection, QuickStart} from "../components";
import {PHONE_LINK} from "../constants/info";

class MainPage extends Component{
	componentDidMount() {
		const modal = document.getElementById("myModal");
		modal.style.display = "block"
	}

	closeModal(){
		const modal = document.getElementById("myModal");
		modal.style.display = "none"
	}
	render () {
		const content = (this.props.param.componentName === "stepByStep") ? <StepByStep/> : <QuickStart/>;
		return(
			<div>
				<div className={`mapsa-main-page-top-section ${this.props.param.topSectionImageClassName || null}`}>
					<Header hide="true" />
					<TopSection/>
				</div>
				{content}
				<div className="modal-container" id="myModal">
					<div
						className="overlay"
						onClick={this.closeModal}/>
					<div className="modal-box">
						<div className="modal-header">
							<img onClick={this.closeModal} className="close-icon" src="../../help/images/close.png" alt="close"/>
						</div>
						<div className="modal-body">
							<div className="title">کاربر عزیز مپسا</div>
							<div className="message">
								<div className="main-message">
									مرکز آموزش مپسا در حال به روز رسانی مطالب، مطابق با تغییرات ایجاد شده در نرم‌افزار می‌باشد و به زودی با محتوای بهتر دردسترس شما خواهد بود.
									پیشنهاد می‌کنیم تا آن زمان از فیلم‌های آموزش سریع مپسا دیدن فرمایید، یا به محتواهای آموزشی صفحه اینستاگرام مپسا مراجعه کنید و یا کتابچه راهنمای مپسا را دانلود نمایید. همچنین هر لحظه می‌توانید سوالات خود را از طریق تماس با واحد پشتیبانی مطرح بفرمایید.
								</div>
								<div className="footer-message">
									<a href="https://mapsa.ir/files/mapsa_android_help.pdf">
										<img src="../../help/images/pdf.png" alt="pdf"/>
										دانلود کتابچه راهنمای مپسا
									</a>
									<a href="https://mapsa.ir/blog/app-education/">
										<img src="../../help/images/play-button.png" alt="pdf"/>
										آموزش سریع نسخه اندروید
									</a>
									<a href="https://mapsa.ir/blog/web-education/">
										<img src="../../help/images/play-button.png" alt="pdf"/>
										آموزش سریع نسخه وب
									</a>
									<a href="https://www.instagram.com/accounts/login/?next=/mapsa.ir/" >
										<img src="../../help/images/instagram.png" alt="pdf"/>
										صفحه اینستاگرام مپسا
									</a>
									<br/>
									<a className="tel" href={PHONE_LINK}>شماره تماس با پشتیبانی: ۰۲۱۶۲۹۹۵۰۵۰</a>
								</div>
							</div>
						</div>
					</div>

				</div>
				<FAQ title={"پرسش های متداول"} clsName="faq-main-page-text-color"/>
				<Banner src={this.props.param.bannerName}/>
				<LastSection/>
				<div className="container-fluid">
					<div className="row">
						<div className="col-12">
							<div className={`mb-5, mapsa-main-page-last-section ${this.props.param.lastSectionImageClassName}`}></div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		);
	}
}

export default withRouter(hot(module)(MainPage));